import React from 'react';
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { afterItems, beforeItems, transformationStats } from '../data/curriculum';
export function TransformationSection() {
  return <section className="bg-brand-main px-4 py-20 md:py-28" data-id="element-167" data-mp="2ww2non90qrti">
      <Reveal className="mx-auto max-w-5xl" data-id="element-168" data-mp="2rz2h8b89bn1v">
        <div className="mx-auto max-w-3xl text-center" data-id="element-169" data-mp="2ryaxbxo0vdrf">
          <p className="mb-4 text-xs font-extrabold tracking-[0.18em] text-brand-green" data-id="element-170" data-mp="2nxh6avfa9iub">UNA LETTERA AI DOCENTI</p>
          <h2 className="text-4xl font-black leading-[1.08] tracking-tight text-brand-deep md:text-5xl" data-id="element-171" data-mp="2j57ndzcl5j1j">
            Da un Docente Sopraffatto a una{' '}
            <span className="italic text-brand-green" data-id="element-172" data-mp="2e4thamujoj65">Guida di Scienze Sicura.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-brand-gray md:text-base" data-id="element-173" data-mp="2968f4hvqfpf2">
            Ogni sera la stessa storia: cercare schede online, incollare attività, chiederti se il contenuto è
            corretto e abbastanza chiaro. Biologia Pronta ti consegna l’anno intero, già pronto, così entri in classe
            sapendo esattamente cosa insegnare e come.
          </p>
        </div>

        <div className="mx-auto my-12 grid max-w-3xl divide-y divide-brand-dark overflow-hidden rounded-2xl border border-brand-dark bg-brand-alt shadow-sm sm:grid-cols-3 sm:divide-x sm:divide-y-0" data-id="element-174" data-mp="5d6c2pitxikt">
          {transformationStats.map(({
          value,
          label
        }) => <div key={label} className="px-5 py-5 text-center" data-id="element-175" data-mp="y2d5ja3ffhz7">
              <strong className="block font-serif text-3xl leading-none text-brand-amber" data-id="element-176" data-mp="12zlr7knsa457">{value}</strong>
              <span className="mt-2 block text-[10px] font-extrabold leading-tight tracking-[0.08em] text-brand-gray" data-id="element-177" data-mp="ozua3b1z07mz">
                {label}
              </span>
            </div>)}
        </div>

        <div className="overflow-hidden rounded-3xl border border-brand-dark bg-brand-alt shadow-[0_18px_45px_rgba(15,81,50,0.10)]" data-id="element-178" data-mp="39qbiyugmhj3u">
          <div className="grid md:grid-cols-2" data-id="element-179" data-mp="3dqd8y6czwo3a">
            <Comparison title="PRIMA" items={beforeItems} positive={false} data-id="element-180" data-mp="1k8xr97fxv4pf" />
            <Comparison title="CON BIOLOGIA PRONTA" items={afterItems} positive data-id="element-181" data-mp="1facqn6wryj0g" />
          </div>
          <div className="border-t border-brand-dark bg-brand-main px-6 py-4 text-center text-xs font-semibold text-brand-gray" data-id="element-182" data-mp="1ajwahf1kkjae">
            Insegnare scienze nel modo giusto dovrebbe essere semplice.
          </div>
        </div>
      </Reveal>
    </section>;
}
function Comparison({
  title,
  items,
  positive
}: {
  title: string;
  items: string[];
  positive: boolean;
}) {
  const Icon = positive ? CheckCircle2Icon : XCircleIcon;
  return <div className={`p-6 md:p-9 ${positive ? 'border-t border-brand-dark bg-brand-alt md:border-l md:border-t-0' : 'bg-[#F4F5F3]'}`} data-id="element-183" data-mp="rm3aolm8sph8">
      <div className="mb-7 flex items-start justify-between gap-4" data-id="element-184" data-mp="2lzcm4iycml24">
        <div data-id="element-185" data-mp="2lyjoq8la57wn">
          <p className={`text-[10px] font-extrabold tracking-[0.16em] ${positive ? 'text-brand-green' : 'text-brand-gray'}`} data-id="element-186" data-mp="2lx8i810g9m1u">
            {positive ? 'IL SISTEMA PRONTO ALL’USO' : 'IL COSTO DI PARTIRE DA ZERO'}
          </p>
          <h3 className="mt-2 font-serif text-2xl font-bold tracking-tight text-brand-deep" data-id="element-187" data-mp="2ti2h35geydhw">{title}</h3>
        </div>
        <div className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full ${positive ? 'bg-brand-green text-white shadow-md' : 'bg-brand-alt text-[#C24141]'}`} data-id="element-188" data-mp="2yavhxi8rh1op">
          <Icon className="h-5 w-5" aria-hidden="true" data-id="element-189" data-mp="26jpotlrgk48x" />
        </div>
      </div>
      <ul className="space-y-2.5" data-id="element-190" data-mp="2aj80rs1ax4zm">
        {items.map(item => <li key={item} className={`flex items-center gap-3 rounded-xl px-3 py-3 ${positive ? 'bg-brand-main' : 'bg-brand-alt/70'}`} data-id="element-191" data-mp="2fj2qvtd95qjm">
            <Icon className={`h-4 w-4 shrink-0 ${positive ? 'text-brand-green' : 'text-[#C24141]'}`} aria-hidden="true" data-id="element-192" data-mp="2kjh03eqlb6j8" />
            <span className={`text-sm leading-snug ${positive ? 'font-semibold text-brand-text' : 'text-brand-gray'}`} data-id="element-193" data-mp="3vwjd5zthddyn">
              {item}
            </span>
          </li>)}
      </ul>
    </div>;
}